import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { mcallenConfig } from "./data";

export default function McAllenPage() {
  return <CityPageTemplate config={mcallenConfig} />;
}